// animate in blocks with stagger
import { animate, scroll, stagger, inView } from "motion";

// Exit early if body has disable-animation class
if (!document.body.classList.contains('disable-animation')) {
   
   document.querySelectorAll("section.cta-columns-1").forEach((section) => {
      const ctaCardImg = section.querySelector("figure.card-img");

      if (ctaCardImg) {
         scroll(animate(ctaCardImg, { y: [-50, 50] }), {
            target: ctaCardImg
         });
      }
   });

   let observerOptions = {
      rootMargin: '-100px 0px -100px 0px', // Adjusts the viewport margins to trigger earlier
      threshold: 0 // Trigger as soon as any part of the element intersects
   };

   const observer = new IntersectionObserver(observerCallback, observerOptions);

   function observerCallback(entries, observer) {
      entries.forEach(entry => {
         if (entry.isIntersecting) {
            animate(
               entry.target.querySelectorAll('.animate-in, .text-columns :is(h1, h2, h3, h4, h5, h6, p, ul:not(ul li ul), ol:not(ol li ol))'),
               { 
                  opacity: [0, 1],
                  transform: ["translateY(24px)", "translateY(0)"]
               },
               {
                  delay: stagger(0.2),
                  duration: .5,
                  easing: [.22, .03, .26, 1]
               }
            );
            observer.unobserve(entry.target);
         }
      });
   }

   // Helper function to check if an element is in view on page load
   function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
         rect.top < window.innerHeight &&
         rect.bottom > 0
      );
   }

   // Run the animation unless the user has prefers-reduced-motion switched on
   if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('section').forEach((el) => {
         if (!el) return;

         // Check if the element is already in view and animate immediately
         if (isElementInViewport(el)) {
            animate(
               el.querySelectorAll('.animate-in:not(.single-page-content .card--cta.animate-in), .text-columns :is(h1, h2, h3, h4, h5, h6, p, ul:not(ul li ul), ol:not(ol li ol))'),
               { 
                  opacity: [0, 1],
                  transform: ["translateY(24px)", "translateY(0)"]
               },
               {
                  delay: stagger(0.2),
                  duration: .5,
                  easing: [.22, .03, .26, 1]
               }
            );
         } else {
            observer.observe(el); // Otherwise, observe for intersection
         }
      });
   } else {
      document.body.classList.add('prefers-reduced-motion');
   }

} else {
   // (Optional) If you want, you can log or add a class if animations are disabled
   console.log('Animations disabled on this page.');
}



// progress bar for single pages
if (document.querySelector('.progress-bar') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
   scroll(animate(".progress-bar .progress", { width: ["0", "100%"] }));
}
